module.exports = __webpack_public_path__ + "img/cooperative0_logo4.0c60c66e.jpg";